import React, { useEffect, useState } from "react"
// import Rating from "@material-ui/lab/Rating"
import TextField from "@material-ui/core/TextField"
import Button from "@material-ui/core/Button"
import List from "@material-ui/core/List"
import ListItem from "@material-ui/core/ListItem"
import Divider from "@material-ui/core/Divider"
import ListItemText from "@material-ui/core/ListItemText"
import ListItemAvatar from "@material-ui/core/ListItemAvatar"
import Avatar from "@material-ui/core/Avatar"
import Typography from "@material-ui/core/Typography"

const PredictionCard = props => {
  const [comments, setComments] = useState([])
  const [comment, setComment] = useState("")

  useEffect(() => {
    const unsubscribe = props.firebase.subscribeToGameComments({
      eid: props.eid,
      onSnapshot: snapshot => {
        const snapshotComments = []
        snapshot.forEach(doc =>
          snapshotComments.push({
            id: doc.id,
            ...doc.data(),
          })
        )

        setComments(snapshotComments)
      },
    })

    return () => {
      if (unsubscribe) unsubscribe()
    }
  }, [])

  return (
    <React.Fragment>
      <h2 style={{ textAlign: "center" }}>{props.data.prediction}</h2>
      <div style={{ display: "flex", justifyContent: "center" }}>
        <div style={{ display: "flex", flexDirection: "column" }}>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <div style={{ display: "flex", flexDirection: "column" }}>
              <img
                style={{
                  margin: 0,
                  width: 400,
                }}
                src={`https://firebasestorage.googleapis.com/v0/b/the-final-score-7860d.appspot.com/o/${props.home_team}.svg?alt=media&token=056a31d2-9681-4785-8a66-7b079d5f2119`}
                alt={`${props.home_team}`}
              />
              <h3 style={{ textAlign: "center" }}>
                {props.data.scores.home.finalScore}
              </h3>
            </div>
            <div style={{ display: "flex", flexDirection: "column" }}>
              <img
                style={{
                  margin: 0,
                  width: 400,
                }}
                src={`https://firebasestorage.googleapis.com/v0/b/the-final-score-7860d.appspot.com/o/${props.away_team}.svg?alt=media&token=056a31d2-9681-4785-8a66-7b079d5f2119`}
                alt={`${props.away_team}`}
              />
              <h3 style={{ textAlign: "center" }}>
                {props.data.scores.away.finalScore}
              </h3>
            </div>
          </div>
          {!!props.user.isAdmin && props.firebase && (
            <div
              style={{
                textAlign: "center",
                display: "flex",
                flexDirection: "column",
              }}
            >
              {/* <Rating
                name="pristine"
                value={3}
                style={{ marginBottom: "1em" }}
              /> */}
              <TextField
                id="comments"
                label="Expert Remarks"
                multiline
                rows={4}
                variant="outlined"
                value={comment}
                onChange={e => {
                  e.persist()
                  setComment(e.target.value)
                }}
              />
              <div style={{ marginTop: "1em" }}>
                <Button
                  disabled={20 > comment.length}
                  onClick={() => {
                    if (20 < comment.length) {
                      props.firebase.postComment({
                        eid: props.eid,
                        comment,
                      })

                      setComment("")
                      document.querySelector("#comments").focus()
                    }
                  }}
                >
                  Post Remark
                </Button>
              </div>
            </div>
          )}

          {!!props.user && (
            <div
              style={{
                textAlign: "center",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <List>
                {comments.map(comment => (
                  <ListItem key={comment.id} alignItems="flex-start">
                    <ListItemAvatar>
                      <Avatar
                        alt={comment.author}
                        src="/static/images/avatar/1.jpg"
                      />
                    </ListItemAvatar>
                    <ListItemText
                      primary={comment.created.toDate().toLocaleString()}
                      secondary={
                        <React.Fragment>
                          <Typography
                            component="span"
                            variant="body2"
                            style={{ display: "inline" }}
                            color="textPrimary"
                          >
                            {comment.author}
                          </Typography>
                          {` - ${comment.comment}`}
                        </React.Fragment>
                      }
                    />
                  </ListItem>
                ))}
              </List>
            </div>
          )}
        </div>
      </div>
    </React.Fragment>
  )
}

export default PredictionCard
